"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationsFromLocale = void 0;
const GetFallbackLocaleList_1 = require("../getFallbackLocaleList/GetFallbackLocaleList");
function getTranslationsFromLocale(envLocale, localeLoader) {
    return __awaiter(this, void 0, void 0, function* () {
        const languagesToLoad = (0, GetFallbackLocaleList_1.getFallbackLocaleList)(envLocale);
        const translationPromises = languagesToLoad.map((lang) => localeLoader(lang)
            .then((module) => ({
            [lang]: module.default,
        }))
            .catch(() => ({})));
        const translationsArray = yield Promise.all(translationPromises);
        return translationsArray.reduce((acc, translations) => (Object.assign(Object.assign({}, acc), translations)), {});
    });
}
exports.getTranslationsFromLocale = getTranslationsFromLocale;
//# sourceMappingURL=GetTranslationsFromLocale.js.map